<template>
  <b-row class="uk-grid uk-width-1-1" style="margin: 0 !important; padding: 0 !important;">
    <b-col class="uk-width-1-1" style="margin: 0 !important; padding: 0 !important;">
      <img src="@/assets/images/logo.svg" alt="logo" class="uk-margin-medium-bottom" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CommonPagesLogo'
}
</script>
